import styles from "./BenefitsGrid.module.scss";
import freemium from "../../assets/benefit-freemium.svg";
import advanced from "../../assets/benefit-advanced.svg";
import optimized from "../../assets/benefit-optimized.svg";
import highly from "../../assets/benefit-highly.svg";
import detailed from "../../assets/benefit-detailed.svg";
import shutdown from "../../assets/benefit-shutdown.svg";
import { useIntl } from "react-intl";

interface Benefit {
  title: string;
  description: string;
  icon: string;
}

function BenefitsGrid() {
  const { formatMessage } = useIntl();
  const benefits: Benefit[] = [
    {
      title: formatMessage({ id: "wlp.benefits.1.title" }),
      description: formatMessage({ id: "wlp.benefits.1.description" }),
      icon: freemium,
    },
    {
      title: formatMessage({ id: "wlp.benefits.2.title" }),
      description: formatMessage({ id: "wlp.benefits.2.description" }),
      icon: advanced,
    },
    {
      title: formatMessage({ id: "wlp.benefits.3.title" }),
      description: formatMessage({ id: "wlp.benefits.3.description" }),
      icon: optimized,
    },
    {
      title: formatMessage({ id: "wlp.benefits.4.title" }),
      description: formatMessage({ id: "wlp.benefits.4.description" }),
      icon: highly,
    },
    {
      title: formatMessage({ id: "wlp.benefits.5.title" }),
      description: formatMessage({ id: "wlp.benefits.5.description" }),
      icon: detailed,
    },
    {
      title: formatMessage({ id: "wlp.benefits.6.title" }),
      description: formatMessage({ id: "wlp.benefits.6.description" }),
      icon: shutdown,
    },
  ];

  return (
    <section className={styles.section} id="benefits">
      <div className={styles.heading}>
        <h2>{formatMessage({ id: "wlp.benefits.heading" })}</h2>
      </div>
      <div className={styles.grid}>
        {benefits.map((benefit) => (
          <article key={benefit.title} className={styles.card}>
            <div className={styles.cardHead}>
              <span className={styles.icon}>
                <img src={benefit.icon} alt="" />
              </span>
              <h3>{benefit.title}</h3>
            </div>
            <p>{benefit.description}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

export { BenefitsGrid };
